function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import _ from "lodash";
import { Table, Form, Row, Col, Button } from "react-bootstrap";

var CheckboxInputTable = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CheckboxInputTable, _React$Component);

  function CheckboxInputTable() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      checkbox: true
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (rowData, colData, rowIndex, colIndex) {
      return function (e) {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            formData = _this$props.formData;

        var valuesInRow = _.get(formData, rowData, []);

        var isIncludedBefore = _.includes(valuesInRow, colData);

        if (isIncludedBefore) {
          valuesInRow = _.reject(valuesInRow, function (value) {
            return value === colData;
          });
        } else {
          valuesInRow.push(colData);
        }

        var obj = _extends({}, formData);

        obj[rowData] = valuesInRow;
        onChange && onChange(obj);

        _this.forceUpdate();
      };
    });

    _defineProperty(_assertThisInitialized(_this), "isCellValueChecked", function (rowData, colData) {
      var formData = _this.props.formData;

      var rowValues = _.get(formData, rowData, []);

      return _.includes(rowValues, colData);
    });

    return _this;
  }

  var _proto = CheckboxInputTable.prototype;

  _proto.renderCell = function renderCell(rowData, colData, rowIndex, colIndex) {
    return /*#__PURE__*/React.createElement(Form.Check, {
      checked: this.isCellValueChecked(rowData, colData),
      name: "radioGroup-" + this.id + "-" + rowIndex,
      onChange: this.handleChange(rowData, colData, rowIndex, colIndex),
      type: "checkbox",
      style: {
        display: "flex",
        justifyContent: "center"
      }
    });
  };

  _proto.renderTable = function renderTable() {
    var _this2 = this;

    var _$get = _.get(this.props, "uiSchema.ui:options", {}),
        rows = _$get.rows,
        columns = _$get.columns;

    return /*#__PURE__*/React.createElement(Table, {
      responsive: true
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null), _.map(columns, function (data, index) {
      return /*#__PURE__*/React.createElement("th", {
        key: index
      }, data);
    }))), /*#__PURE__*/React.createElement("tbody", null, _.map(rows, function (rowData, rowIndex) {
      return /*#__PURE__*/React.createElement("tr", {
        key: rowIndex
      }, /*#__PURE__*/React.createElement("td", {
        key: rowIndex
      }, rowData), _.map(columns, function (colData, colIndex) {
        return /*#__PURE__*/React.createElement("td", {
          key: colIndex
        }, _this2.renderCell(rowData, colData, rowIndex, colIndex));
      }));
    })));
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderTable());
  };

  return CheckboxInputTable;
}(React.Component);

export default CheckboxInputTable;